export function uniqueBy(items, key) {
    const filtered = [];
    for (const item of items) {
        if (!filtered.some(x => x[key] === item[key])) {
            filtered.push(item);
        }
    }
    return filtered;
}
